import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;

    .list {
        > * {
            padding-bottom: 4em;

            &:nth-of-type(odd) {
                flex-direction: row-reverse;
            }

            &:last-of-type {
                padding-bottom: 0;
            }
        }
    }

    @media all and (max-width: ${variables.tabletS}) {
        .list {
            .public-layout-sections-blocks-two-col {
                flex-direction: column;
            }
        }
    }
`;

